import {baseAxios} from '../helper/axiosHelper';

export const totpService = {
    deleteTotp,
    getCode,
    getQr,
    validate,
    getTotp,
    insertTotp
};

function getCode() {

    return baseAxios.get('totp/code')
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function getQr() {

    return baseAxios.get('totp/qrcode')
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function validate(code) {

    return baseAxios.get('totp/validate',{params: {code: code}})
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

function deleteTotp() {

    return baseAxios.delete('auth/totp/' )
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

function getTotp() {

    return baseAxios.get('auth/totp/' )
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

function insertTotp() {

    return baseAxios.post('auth/totp/' )
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

